// @generated by web/tools/codegen — DO NOT EDIT
// mode: client

import type { RouteObject } from 'react-router';
import { type MessageKeys } from '@/shared/i18n/messages_gen';
import { r } from '@letsgethome/routes';

import { ErrorBoundary as RootErrorBoundary } from '../app/root-layout';
import { FeatureErrorBoundary } from '../shared/components/FeatureErrorBoundary';

function createRouteTree(): RouteObject[] {
  return [
    {
      id: 'root',
      lazy: () => import('../app/root-layout'),
      children: [
        {
          id: 'marketing',
          handle: { chrome: 'hub' },
          ErrorBoundary: FeatureErrorBoundary,
          children: [
            {
              id: 'marketing/home',
              index: true,
              lazy: () => import('../features/storefront/home/pages/home'),
              loader: () => null,
            },
            {
              id: 'marketing/about',
              path: 'about',
              lazy: () => import('../features/storefront/marketing/pages/about'),
            },
            {
              id: 'marketing/terms',
              path: 'terms',
              lazy: () => import('../features/storefront/marketing/pages/terms'),
            },
            {
              id: 'marketing/privacy',
              path: 'privacy',
              lazy: () => import('../features/storefront/marketing/pages/privacy'),
            },
            {
              id: 'marketing/contact',
              path: 'contact',
              lazy: () => import('../features/storefront/marketing/pages/contact'),
            },
            {
              id: 'marketing/feedback',
              path: 'feedback',
              lazy: () => import('../features/storefront/marketing/pages/feedback'),
            },
            {
              id: 'marketing/help',
              path: 'help',
              lazy: () => import('../features/storefront/marketing/pages/help'),
            },
            {
              id: 'marketing/forms',
              path: 'forms',
              lazy: () => import('../features/storefront/marketing/pages/forms'),
            },
            {
              id: 'marketing/services',
              path: 'services',
              lazy: () => import('../features/storefront/marketing/pages/services'),
            },
            {
              id: 'marketing/blog',
              path: 'blog',
              lazy: () => import('../features/storefront/blog/pages/blog'),
              loader: () => null,
            },
            {
              id: 'marketing/blog-post',
              path: 'blog/:slug',
              lazy: () => import('../features/storefront/blog/pages/blog-post'),
              loader: () => null,
            },
            {
              id: 'marketing/blog-category',
              path: 'blog/category/:slug',
              lazy: () => import('../features/storefront/blog/pages/blog-category'),
              loader: () => null,
            },
            {
              id: 'marketing/blog-legacy-post',
              path: 'blog/:slug/:legacyId',
              loader: () => null,
            },
            {
              id: 'marketing/news-legacy-post',
              path: 'news/:slug/:legacyId',
              loader: () => null,
            },
            {
              id: 'marketing/news-legacy',
              path: 'news/:slug',
              loader: () => null,
            },
            {
              id: 'marketing/partners',
              path: 'partners',
              lazy: () => import('../features/storefront/partners/pages/partners'),
              loader: () => null,
            },
            {
              id: 'marketing/partner-detail',
              path: 'partners/:slug',
              lazy: () => import('../features/storefront/partners/pages/partner-detail'),
              loader: () => null,
            },
            {
              id: 'marketing/tools',
              path: 'tools',
              lazy: () => import('../features/storefront/marketing/pages/tools'),
            },
            {
              id: 'marketing/tools-school-map',
              path: 'tools/hk-school-map',
              lazy: () => import('../features/storefront/marketing/pages/tools-school-map'),
            },
            {
              id: 'marketing/tools-buy-vs-rent',
              path: 'tools/buy-vs-rent-calculator',
              lazy: () => import('../features/storefront/marketing/pages/tools-buy-vs-rent'),
            },
            {
              id: 'marketing/tools-chinese-converter',
              path: 'tools/chinese-converter',
              lazy: () => import('../features/storefront/marketing/pages/tools-chinese-converter'),
            },
            {
              id: 'marketing/tools-rates-calc',
              path: 'tools/rates-government-rent-calculator',
              lazy: () => import('../features/storefront/marketing/pages/tools-rates-calc'),
            },
            {
              id: 'marketing/tools-rental-yield',
              path: 'tools/rental-yield-calculator',
              lazy: () => import('../features/storefront/marketing/pages/tools-rental-yield'),
            },
            {
              id: 'marketing/tools-stamp-duty',
              path: 'tools/stamp-duty-calculator',
              lazy: () => import('../features/storefront/marketing/pages/tools-stamp-duty'),
            },
            {
              id: 'marketing/tools-mortgage',
              path: 'tools/mortgage-calculator',
              lazy: () => import('../features/storefront/marketing/pages/tools-mortgage'),
            },
            {
              id: 'marketing/tools-affordability',
              path: 'tools/affordability-calculator',
              lazy: () => import('../features/storefront/marketing/pages/tools-affordability'),
            },
          ],
        },
        {
          id: 'listings',
          path: 'listings',
          handle: { chrome: 'canvas', backTo: r('/') },
          ErrorBoundary: FeatureErrorBoundary,
          children: [
            {
              id: 'listings/index',
              index: true,
              loader: () => null,
            },
            {
              id: 'listings/rent',
              path: 'rent',
              lazy: () => import('../features/storefront/listings/pages/hub'),
              loader: () => null,
            },
            {
              id: 'listings/buy',
              path: 'buy',
              lazy: () => import('../features/storefront/listings/pages/hub'),
              loader: () => null,
            },
            {
              id: 'listings/rent-type',
              path: 'rent/:slug',
              handle: { backTo: r('/listings/rent') },
              lazy: () => import('../features/storefront/listings/pages/type-facet'),
              loader: () => null,
            },
            {
              id: 'listings/buy-type',
              path: 'buy/:slug',
              handle: { backTo: r('/listings/buy') },
              lazy: () => import('../features/storefront/listings/pages/type-facet'),
              loader: () => null,
            },
          ],
        },
        {
          id: 'listing-detail',
          path: 'listings/:slug',
          handle: { chrome: 'focus', backTo: r('/listings/rent'), title: 'pageTitles.listing' satisfies MessageKeys<''> },
          ErrorBoundary: FeatureErrorBoundary,
          children: [
            {
              id: 'listing-detail/index',
              index: true,
              lazy: () => import('../features/storefront/listings/pages/detail'),
              loader: () => null,
            },
            {
              id: 'listing-detail/inquiry',
              path: 'inquiry',
              handle: { title: 'inquiry.title' satisfies MessageKeys<''> },
              lazy: () => import('../features/storefront/listings/pages/inquiry'),
              loader: () => null,
            },
          ],
        },
        {
          id: 'market',
          path: 'market',
          handle: { chrome: 'hub' },
          ErrorBoundary: FeatureErrorBoundary,
          children: [
            {
              id: 'market/index',
              index: true,
              lazy: () => import('../features/storefront/market/pages/index'),
              loader: () => null,
            },
          ],
        },
        {
          id: 'districts',
          path: 'districts',
          handle: { chrome: 'hub' },
          ErrorBoundary: FeatureErrorBoundary,
          children: [
            {
              id: 'districts/index',
              index: true,
              lazy: () => import('../features/storefront/districts/pages/index'),
              loader: () => null,
            },
          ],
        },
        {
          id: 'district-detail',
          path: 'districts/:slug',
          handle: { chrome: 'article', backTo: r('/districts'), title: 'pageTitles.district' satisfies MessageKeys<''> },
          ErrorBoundary: FeatureErrorBoundary,
          children: [
            {
              id: 'district-detail/index',
              index: true,
              lazy: () => import('../features/storefront/districts/pages/detail'),
              loader: () => null,
            },
            {
              id: 'district-detail/rent',
              path: 'rent',
              lazy: () => import('../features/storefront/districts/pages/facet'),
              loader: () => null,
            },
            {
              id: 'district-detail/buy',
              path: 'buy',
              lazy: () => import('../features/storefront/districts/pages/facet'),
              loader: () => null,
            },
          ],
        },
        {
          id: 'estates',
          path: 'estates',
          handle: { chrome: 'hub' },
          ErrorBoundary: FeatureErrorBoundary,
          children: [
            {
              id: 'estates/index',
              index: true,
              lazy: () => import('../features/storefront/estates/pages/index'),
              loader: () => null,
            },
          ],
        },
        {
          id: 'estate-detail',
          path: 'estates/:slug',
          handle: { chrome: 'article', backTo: r('/estates'), title: 'pageTitles.estate' satisfies MessageKeys<''> },
          ErrorBoundary: FeatureErrorBoundary,
          children: [
            {
              id: 'estate-detail/index',
              index: true,
              lazy: () => import('../features/storefront/estates/pages/detail'),
              loader: () => null,
            },
            {
              id: 'estate-detail/transactions',
              path: 'transactions',
              lazy: () => import('../features/storefront/transactions/pages/estate'),
              loader: () => null,
            },
          ],
        },
        {
          id: 'transactions',
          path: 'transactions',
          handle: { chrome: 'hub' },
          ErrorBoundary: FeatureErrorBoundary,
          children: [
            {
              id: 'transactions/index',
              index: true,
              lazy: () => import('../features/storefront/transactions/pages/index'),
              loader: () => null,
            },
          ],
        },
        {
          id: 'account',
          handle: { chrome: 'focus', backTo: r('/profile') },
          ErrorBoundary: FeatureErrorBoundary,
          children: [
            {
              id: 'account/profile',
              path: 'profile',
              handle: { chrome: 'hub' },
              lazy: () => import('../features/account/pages/profile'),
              loader: () => null,
            },
            {
              id: 'account/saved',
              path: 'saved',
              handle: { chrome: 'hub' },
              lazy: () => import('../features/account/pages/saved'),
              loader: () => null,
            },
            {
              id: 'account/settings',
              path: 'account/settings',
              handle: { title: 'settings.title' satisfies MessageKeys<''> },
              lazy: () => import('../features/account/pages/settings'),
              loader: () => null,
            },
            {
              id: 'account/support',
              path: 'account/support',
              handle: { title: 'support.title' satisfies MessageKeys<''> },
              lazy: () => import('../features/support/pages/index'),
            },
            {
              id: 'account/listings',
              path: 'account/listings',
              handle: { title: 'pageTitles.myListings' satisfies MessageKeys<''> },
              lazy: () => import('../features/account/pages/listings'),
              loader: () => null,
            },
            {
              id: 'account/reports',
              path: 'account/reports',
              handle: { title: 'pageTitles.myReports' satisfies MessageKeys<''> },
              lazy: () => import('../features/account/pages/reports'),
              loader: () => null,
            },
            {
              id: 'account/listing-detail',
              path: 'account/listings/:listingId',
              handle: { backTo: r('/account/listings'), title: 'pageTitles.listingEditor' satisfies MessageKeys<''> },
              lazy: () => import('../features/account/pages/listing-detail'),
              loader: () => null,
            },
            {
              id: 'account/listing-edit',
              path: 'account/listings/:listingId/edit/:section',
              handle: { backTo: r('/account/listings'), title: 'pageTitles.listingEditSection' satisfies MessageKeys<''> },
              lazy: () => import('../features/account/pages/listing-edit'),
              loader: () => null,
            },
          ],
        },
        {
          id: 'wizard',
          handle: { chrome: 'flow' },
          ErrorBoundary: FeatureErrorBoundary,
          lazy: () => import('../features/wizard/pages/layout'),
          children: [
            {
              id: 'wizard/new-listing',
              path: 'account/listings/new',
              lazy: () => import('../features/wizard/pages/new-listing'),
            },
            {
              id: 'wizard/address',
              path: 'account/listings/:listingId/wizard/address',
              lazy: () => import('../features/wizard/pages/address'),
              loader: () => null,
            },
            {
              id: 'wizard/size',
              path: 'account/listings/:listingId/wizard/size',
              lazy: () => import('../features/wizard/pages/size'),
              loader: () => null,
            },
            {
              id: 'wizard/pricing',
              path: 'account/listings/:listingId/wizard/pricing',
              lazy: () => import('../features/wizard/pages/pricing'),
              loader: () => null,
            },
            {
              id: 'wizard/amenities',
              path: 'account/listings/:listingId/wizard/amenities',
              lazy: () => import('../features/wizard/pages/amenities'),
              loader: () => null,
            },
            {
              id: 'wizard/media',
              path: 'account/listings/:listingId/wizard/media',
              lazy: () => import('../features/wizard/pages/media'),
              loader: () => null,
            },
            {
              id: 'wizard/description',
              path: 'account/listings/:listingId/wizard/description',
              lazy: () => import('../features/wizard/pages/description'),
              loader: () => null,
            },
            {
              id: 'wizard/payment',
              path: 'account/listings/:listingId/wizard/payment',
              lazy: () => import('../features/wizard/pages/payment'),
              loader: () => null,
            },
          ],
        },
        {
          id: 'conversations',
          handle: { chrome: 'panel', backTo: r('/conversations') },
          ErrorBoundary: FeatureErrorBoundary,
          children: [
            {
              id: 'conversations/index',
              path: 'conversations',
              handle: { chrome: 'inbox' },
              lazy: () => import('../features/conversations/pages/index'),
              loader: () => null,
            },
            {
              id: 'conversations/thread',
              path: 'conversations/:conversationId',
              handle: { title: 'conversations.title' satisfies MessageKeys<''> },
              lazy: () => import('../features/conversations/pages/thread'),
              loader: () => null,
            },
          ],
        },
        {
          id: 'preview/post',
          path: 'preview/posts/:id',
          handle: { chrome: 'flow' },
          lazy: () => import('../features/storefront/preview/pages/post'),
          loader: () => null,
        },
      ],
    },
  ];
}

export const localizedRoutes: RouteObject[] = [
  { id: 'locale', path: ':locale?', loader: () => null, ErrorBoundary: RootErrorBoundary, children: createRouteTree() },
];
